<app-banner-app [retroSelected]="false" [Parametros]="this.parametro" [PaginaAnterior]="'DatosInquilino'"
    [IdentLead]="this.leadId"></app-banner-app>

<div  class="main-content" [ngClass]="addSpacing ? 'mt-5 pt-4' : ''">
    <div class="container">
        <div class="row justify-content-center text-center">
            <div class="col-sm-12 col-md-5 px-5 px-lg-0" >
                <div class="textoArriba" >
                    <div>
                        <h1 class="texto2">Listo, el proceso continúa con tu inquilino.</h1>
                        <span class="texto1">Por favor, avísale a tu inquilino que debe revisar su buzón de correo electrónico para completar su información y firmar el contrato. 
                        </span>
                    </div>
                    <img src="./assets/img/Pago_aprobado.png" priority />
                </div>
                
                <div class="container tamanioBoton">
                    <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit" (click)="entendido()">
                        Entendido
                    </button>
                </div>
                
            </div>
        </div>
    </div>

</div>

<div >
    <app-footer-app />
</div>